module.exports = __webpack_public_path__ + "img/关闭.63bd4cda.svg";